import React from 'react';
import Logo from '../../../components/loggedout/Header/logo';
import * as S from "./style";
import { ContainerWrapper } from "../../../../../landing-pages/js/common/styled-components/styled-components";
import CartoonImg from "~images/oddbods/splashxoddbods.svg";

const Header = () => {
    return (
        <ContainerWrapper>
            <S.ContentWrapper>
            <S.SplashLogo>
                <Logo src={CartoonImg}  noRedirection={true}/>
            </S.SplashLogo>
            </S.ContentWrapper>
        </ContainerWrapper>
    )
}

export default Header;